 <template>
  <div class="foslink-footer">
    <div class="w-1200">
      <div class="footer-top">
        <div class="footer-logo">
          <img :src="logo" alt="">
          <div>中消云</div>
        </div>
        <div class="footer-menu">
          <div class="footer-title">功能导航</div>
          <ul class="footer-m-list">
            <li :class="{'is-active':activeName==item.name}" v-for="(item, index) in menuList" :key="index"><span class="menu-title" @click="goPage(item)">{{item.title}}</span></li>
          </ul>
        </div>
        <div class="footer-menu">
          <div class="footer-title">关注我们</div>
          <div class="footer-ewm">
            <!-- <div>
              <img src="/images/wx.png" alt="">
            </div> -->
            <div>
              <img src="/images/wx.png" alt="">
            </div>
          </div>
        </div>
        <div class="footer-menu footer-concat">
          <div class="footer-title">联系我们</div>
          <p>地址：北京市顺义区国门商务区翼之城3号楼</p>
          <p>联系电话：010-89491983</p>
          <p>举报电话：010-65009693</p>
        </div>
      </div>
      <div class="footer-bootom"> COPYRIGHT 2008-2024 © 2024 中消云物联网科技研究院 <a target="_blank" href="https://beian.miit.gov.cn">京ICP备16050337号-6</a>
      </div>
    </div>
  </div>
</template>

<script>
import { menuList } from "./common"
const logo = '/images/foslink-logo.png'
export default {
  data (){
    return{
      logo,
      menuList,
      activeName: '',
    }
  },
  watch: {
    $route: {
      handler(n, o){
        this.initPage()
      },
      deep: true
    }
  },
  created (){
    this.initPage()
  },
  methods: {
    initPage(){
      let routeName = this.$route.name
      if(routeName === 'productDetails' || routeName === 'prdTrain' || routeName === 'bigDanger') {
        this.activeName = 'product'
      } else if(routeName === 'caseDetails') {
        this.activeName = 'case'
      } else if(routeName === 'deviceInfo') {
        this.activeName = 'device'
      } else if(routeName === 'apply') {
        this.activeName = 'maintenance'
      } else {
        this.activeName = this.$route.name
      }
    },
    goPage (item){
      this.$router.push({path: item.path})
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/menu.scss';
</style>


// WEBPACK FOOTER //
// src/views/components/AppFooter.vue